import { AuthService } from '@app/core/auth/auth.service';
import { ElementRef } from '@angular/core';
import { PermissionCV } from '@app/core/user/model/PermissionCV.model';
import { Permission } from '@app/core/user/model/Permission.model';
import { EntityCV } from '../model/cv/EntityCV.model';
import { ActionCV } from '../model/cv/ActionCV.model';
import { ValidationCV } from '../model/cv/ValidationCV';
import { EntityInterface } from '../model/entity/interfaces/entityInterface.model';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormGroup } from '@angular/forms';


export abstract class AbstractComponent {


  // ****************************** Propiedades **********************

  // codigo de error
  errorCode = '';
  // catalogo de permisos
  permissionsCV: PermissionCV = new PermissionCV();
  // catalogo de entitdades
  entitiesCV: EntityCV = new EntityCV();
  // catalogo de acciones
  actionsCV: ActionCV = new ActionCV();
  // catalogo de validaciones
  validationsCV: ValidationCV = new ValidationCV();

  private textBeforeSpinning: any = {};

  // ****************************** constructor ************************

  constructor(
      public authService: AuthService,
      public translate: TranslateService
  ) {
  }

  hasPermission(permission: Permission, level?: string): boolean {
    return this.authService.havePermission(permission.code, level);
  }

  startSpinnerElement(element: ElementRef, text?: string): void {
    const nativeElement = element.nativeElement;
    const id = nativeElement.id;
    const beforeText = nativeElement.innerText;
    this.textBeforeSpinning[id] = beforeText;
    nativeElement.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
                              (text !== undefined && text !== null ? ' ' + text : '');
    nativeElement.disabled = true;
  }

  stopSpinnerElement(element: ElementRef): void {
    const nativeElement = element.nativeElement;
    const id = nativeElement.id;
    const beforeText = this.textBeforeSpinning[id];
    nativeElement.innerHTML = beforeText;
    nativeElement.disabled = false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  isConnectionError(error: any): boolean {
    if (error.status !== undefined && error.status !== null) {
      if (error.status === 0 &&
          error.status === 404 &&
          error.status === 405 &&
          error.status === 500 &&
          error.status === 501) {

        this.errorCode = 'common.errors.connection';
        return true;

      }
    } else {
      this.errorCode = 'common.errors.connection';
      return true;
    }
    return false;
  }

  jsonParse(element: EntityInterface): string {
    return JSON.stringify(element);
  }

  // getCheckedToggleValue(id: string): boolean {
  //   const element: any = document.getElementById(id);
  //   if (!element) {
  //     return null;
  //   } else {
  //     const value = element.checked;
  //     return value as boolean;
  //   }
  // }

  changeCkeckboxToToggle(): void {
    // $('input[type="checkbox"]').each((index: number, value: any) => {
    //   const object: any = $(value);
    //   const onLabel = object[0].dataset.on;
    //   const offLabel = object[0].dataset.off;
    //   const onLabelTraducction = this.translate.instant(onLabel);
    //   const offLabelTaduction = this.translate.instant(offLabel);
    //   object.bootstrapToggle({
    //     on: onLabelTraducction,
    //     off: offLabelTaduction
    //   });
    // });
  }

  //changeCkeckboxToToggleById(idCheckbox: string, active: boolean): void {
    // $('#' + idCheckbox).each((index: number, value: any) => {
    //   const object: any = $(value);
    //   // const onLabel = object[0].dataset.on;
    //   // const offLabel = object[0].dataset.off;
    //   // const onLabelTraducction = this.translate.instant(onLabel);
    //   // const offLabelTaduction = this.translate.instant(offLabel);
    //   object.bootstrapToggle(active === true ? 'on' : 'off');
    // });
  //}

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateAndValidityControl(form: FormGroup, controlName: string, element?: any): void {
    setTimeout(() => {
      this.updateAndValidityControlWithoutTimeout(form, controlName, element);
    }, 30);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateAndValidityControlWithoutTimeout(form: FormGroup, controlName: string, element?: any): void {
    if (element) {
      if (form.get(controlName).value !== element.value) {
        form.get(controlName).setValue(element.value);
      }
    }
    form.get(controlName).updateValueAndValidity();
    if (element) {
      this.checkInputIncorrect(element, form);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  checkInputIncorrect(element: any, form: FormGroup): void {
    if (element.validity && element.validity.badInput) {
      const control: AbstractControl = form.get(element.attributes.formcontrolname.value);
      control.setErrors({incorrect: true});
    } else {
      const control: AbstractControl = form.get(element.attributes.formcontrolname.value);
      if (control.hasError('incorrect')) {
        control.setErrors({'incorrect': null});
        control.updateValueAndValidity();
      }
    }
  }

}
